import { useQuery } from "@tanstack/react-query";
import { Handshake } from "lucide-react";
import api from "@/lib/api";
import { FadeUp } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

export default function Partners() {
  const { lang } = useLang();
  const zh = lang === "zh";
  const { data: partners = [] } = useQuery({
    queryKey: ["partners"],
    queryFn: () => api.get("/partners").then((r) => r.data),
    staleTime: 60_000,
  });
  if (!partners.length) return null;

  return (
    <section data-testid="partners" className="py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-[1800px] mx-auto px-4 md:px-8">
        <FadeUp className="flex items-end justify-between gap-6 border-b border-white/10 pb-6 mb-10 md:mb-16">
          <div>
            <div className="font-mono2 text-xs text-[#ffde00] tracking-[0.3em] mb-3">04 — ASSOCIATES & STRATEGIC PARTNERS</div>
            <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] text-[#f5f5f5]">{zh ? "合作伙伴" : "OUR PARTNERS"}</h2>
          </div>
          <Handshake size={32} className="text-[#ffde00] hidden md:block" />
        </FadeUp>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {partners.map((p, i) => (
            <FadeUp key={p.id || i} delay={Math.min(i * 0.05, 0.3)}>
              <div
                className="group border border-white/10 bg-[#050505] hover:border-[#ffde00] transition-colors duration-300 p-6 h-full flex flex-col items-center justify-center text-center"
                data-testid={`partner-card-${i}`}
              >
                {p.image && (
                  <img
                    src={p.image}
                    alt={p.name}
                    loading="lazy"
                    className="max-h-20 max-w-full object-contain opacity-85 group-hover:opacity-100 group-hover:scale-105 transition duration-500"
                  />
                )}
                <div className="mt-4 leading-tight">
                  <div className="font-zh text-xs text-[#f5f5f5] font-bold uppercase">{p.name}</div>
                  <div className="font-mono2 text-[9px] text-[#ffde00] tracking-[0.2em] mt-1">{p.role}</div>
                  {p.region && <div className="font-mono2 text-[9px] text-[#52525b] tracking-[0.2em] mt-0.5">{p.region}</div>}
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-8 text-center">
          <p className="font-mono2 text-[10px] text-[#52525b] tracking-[0.3em]">— AND MORE 年度合作伙伴持续增加中 —</p>
        </FadeUp>
      </div>
    </section>
  );
}
